import React, { useMemo, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './PaymentPage.css';
import { getServiceById } from './servicesData';
import wxIcon from '../image/微信 .png';
import aliIcon from '../image/支付宝 .png';

const PaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const serviceId = params.get('serviceId');
  const service = useMemo(() => getServiceById(serviceId), [serviceId]);

  // 获取预约信息
  const bookingInfo = useMemo(() => {
    const address = params.get('address');
    const date = params.get('date');
    const time = params.get('time');
    const phone = params.get('phone');
    const notes = params.get('notes');
    
    // 如果有预约信息，返回格式化的对象
    if (address && date && time && phone) {
      return {
        address,
        date,
        time,
        phone,
        notes: notes || ''
      };
    }
    return null;
  }, [params]);

  const [payMethod, setPayMethod] = useState('alipay');
  const [isPaying, setIsPaying] = useState(false);

  if (!service) {
    return (
      <div className="payment-page">
        <header className="payment-header">
          <Link to="/" className="back-btn">← 返回</Link>
          <h1>支付</h1>
        </header>
        <div className="container">
          <div className="not-found">未找到订单信息</div>
        </div>
      </div>
    );
  }

  const handleConfirmPay = async () => {
    setIsPaying(true);
    // 模拟支付中
    await new Promise(r => setTimeout(r, 1200));
    setIsPaying(false);
    
    // 将预约信息传递给支付成功页面
    const successParams = new URLSearchParams({ serviceId: service.id });
    if (bookingInfo) {
      Object.entries(bookingInfo).forEach(([key, value]) => {
        if (value) successParams.set(key, value);
      });
    }
    
    navigate(`/payment-success?${successParams.toString()}`);
  };

  // 格式化日期时间显示
  const formatDateTime = (date, time) => {
    if (!date || !time) return '';
    
    const dateObj = new Date(`${date} ${time}`);
    const formatDate = dateObj.toLocaleDateString('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long'
    });
    const formatTime = dateObj.toLocaleTimeString('zh-CN', {
      hour: '2-digit',
      minute: '2-digit'
    });
    
    return `${formatDate} ${formatTime}`;
  };

  return (
    <div className="payment-page">
      <header className="payment-header">
        <Link to={`/detail?serviceId=${service.id}`} className="back-btn">← 返回</Link>
        <h1>确认订单与支付</h1>
      </header>

      <div className="container">
        <section className="card order-card">
          <h3>订单信息</h3>
          <div className="order-row">
            <img src={service.image} alt={service.name} />
            <div className="order-info">
              <div className="title">{service.name}</div>
              <div className="sub">{service.duration} · ¥{service.price}</div>
            </div>
            <div className="order-amount">¥{service.price}</div>
          </div>
        </section>

        {/* 预约信息卡片 */}
        {bookingInfo && (
          <section className="card booking-info-card">
            <h3>预约信息</h3>
            <div className="booking-details">
              <div className="booking-item">
                <span className="booking-label">服务地址：</span>
                <span className="booking-value">{bookingInfo.address}</span>
              </div>
              <div className="booking-item">
                <span className="booking-label">服务时间：</span>
                <span className="booking-value">{formatDateTime(bookingInfo.date, bookingInfo.time)}</span>
              </div>
              <div className="booking-item">
                <span className="booking-label">联系电话：</span>
                <span className="booking-value">{bookingInfo.phone}</span>
              </div>
              {bookingInfo.notes && (
                <div className="booking-item">
                  <span className="booking-label">注意事项：</span>
                  <span className="booking-value">{bookingInfo.notes}</span>
                </div>
              )}
            </div>
          </section>
        )}

        <section className="card pay-card">
          <h3>支付方式</h3>
          <div className="pay-options">
            <label className={`pay-option ${payMethod === 'alipay' ? 'active' : ''}`}>
              <input
                type="radio"
                name="pay"
                value="alipay"
                checked={payMethod === 'alipay'}
                onChange={() => setPayMethod('alipay')}
              />
              <img src={aliIcon} alt="支付宝" />
              <span>支付宝支付</span>
            </label>
            <label className={`pay-option ${payMethod === 'wechat' ? 'active' : ''}`}>
              <input
                type="radio"
                name="pay"
                value="wechat"
                checked={payMethod === 'wechat'}
                onChange={() => setPayMethod('wechat')}
              />
              <img src={wxIcon} alt="微信" />
              <span>微信支付</span>
            </label>
          </div>
        </section>

        <section className="card amount-card">
          <div className="row">
            <span>应付金额</span>
            <strong className="amount">¥{service.price}</strong>
          </div>
        </section>
      </div>

      <div className="payment-footer">
        <button className="confirm-btn" onClick={handleConfirmPay} disabled={isPaying}>
          {isPaying ? '支付中...' : '确认支付'}
        </button>
      </div>
    </div>
  );
};

export default PaymentPage;

